(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'TabDomains', 'TabFleets', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', '$state', 'AlertService', 'pagingParams'];

    function UserManagementController(Principal, TabDomains, TabFleets, User, ParseLinks, paginationConstants, JhiLanguageService, $state, AlertService, pagingParams) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN'];
        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.charToSearch = pagingParams.search;
        vm.setActive = setActive;
        vm.impersonate = impersonate;
        vm.changePageSize = changePageSize;
        vm.totalItems = null;
        vm.users = [];
        vm.domains = [];
        vm.fleets = [];
        vm.active = true;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;


        if(vm.filterDomain === undefined) {
            var allDomain = {}
            allDomain.id = -1;
            allDomain.domainName = "All";
            vm.domains.push(allDomain);
            vm.filterDomain = allDomain;
            var allFleets = {}
            allFleets.id = -1;
            allFleets.fleetName = "All";
            vm.filterFleet = allFleets;
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.loadAll();
        function loadAll () {
            TabDomains.query({
                page: 0,
                size: 1000 }, function (result) {
                vm.domains = [];
                allDomain = {}
                allDomain.id = -1;
                allDomain.domainName = "All";
                vm.domains.push(allDomain);
                result.forEach(function (val) {
                    vm.domains.push(val);
                })
            });
            User.query({
                query: vm.charToSearch,
                domain: vm.filterDomain.id,
                fleet: vm.filterFleet.id,
                status: vm.active,
                page: vm.page - 1,
                size: vm.itemsPerPageChosen
            }, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.users = result;
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        vm.showUserByStatus = function () {
            if(vm.userStatus == "all"){
                vm.active = null;
            }else if (vm.userStatus == "") {
                vm.active = true;
            } else if (vm.userStatus == "inactive") {
                vm.active = false;
            }
            loadAll();
        }

        vm.search = function () {
            vm.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        function changePageSize() {
            // if ((vm.queryCount / vm.itemsPerPageChosen) < vm.page)
            //    vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            // transition

            vm.page = 1;
            vm.loadAll();
        }


        function impersonate(user) {
            User.get({login: user.login}, function(result) {
                if(result.domains.length > 0) {
                    User.impersonate(user);
                    $state.go("context", null, {reload: true});
                } else {
                    AlertService.error("No domains found for this user");
                }
            });
        }

        vm.filterDomains = function () {
            TabFleets.domains({id:vm.filterDomain.id}, function (result) {
                if(vm.filterDomain.id == -1) {
                    loadAll();
                } else {
                    vm.fleets = [];
                    result.forEach(function (val) {
                        vm.fleets.push(val);
                    })
                    var allFleets = {}
                    allFleets.id = -1;
                    allFleets.fleetName = "All";
                    vm.fleets.push(allFleets);
                    vm.filterFleet = allFleets;
                    loadAll();
                }
            })
        }

        vm.newInvitation = function () {
            $state.go('invitation', null, {reload: true});
        }

        vm.invitationList = function () {
            $state.go('invitationList',null,{reload: true})
        }
    }
})();
